<!--
 * @Description: 管理员详情
 * @Author: wanqian
 * @Date: 2022-03-16 16:43:52
-->
<template>
	<el-dialog :title="dialogTitle" :visible.sync="visible"	@open="openDialog" width="960px" center 
		:before-close="handleCloseDialog"	:close-on-click-modal="false" style="text-align: left;" class="dialog-admin">
		<el-form class="adminForm" label-position="top" :model="admin" :rules="rules" ref="adminForm" 
			style="padding: 20px 30px;" label-width="100px">
			<el-row :gutter="50" type="flex" justify="space-between">
				<el-col :span="9" style="text-align: left">
					<el-form-item label="姓名：" prop="name">
						<el-input style="width: 100%" v-model.trim="admin.name" size="small" :disabled="registDisabled" 
							placeholder="请输入姓名">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="9" style="text-align: left">
					<el-form-item label="性别：" prop="gender">
						<el-radio-group v-model="admin.gender" :disabled="registDisabled">
							<el-radio v-for="(value, key) in genderMap" :key="parseInt(key)" :label="parseInt(key)">
								{{value}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :span="6" style="text-align: left; position: relative;">
					<el-form-item style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
						<el-image v-if="registDisabled" class="avatar" :src="photoPath" :preview-src-list="previewImgList" 
							fit="cover"></el-image>
						<el-upload v-else ref="upload" class="avatar-uploader" accept="image/jpeg,image/png" 
							:auto-upload="false" :disabled="registDisabled" action="" :show-file-list="false" 
							:on-change="handleAdminLogoChange">
							<el-image :src="photoPath" fit="cover" class="avatar"></el-image>
							<span class="text-logo-hover">点击更换图片</span>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="50" type="flex" justify="space-between">
				<el-col :span="9" style="text-align: left">
					<el-form-item label="手机号：" prop="mobile">
						<el-input style="width: 100%" v-model.trim="admin.mobile" size="small" :disabled="registDisabled" 
							placeholder="请输入手机号">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="9" style="text-align: left">
					 <el-form-item label="邮箱：" prop="email">
						<el-input style="width: 100%" v-model.trim="admin.email" size="small" :disabled="registDisabled" 
							placeholder="请输入邮箱" maxlength="100">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6"></el-col>
			</el-row>
			<el-row :gutter="50" type="flex" justify="space-between">
				<el-col :span="9" style="text-align: left">
					<el-form-item label="账户名：" prop="username">
						<el-input v-model.trim="admin.username" size="small" maxlength="30" :disabled="registDisabled" 
							placeholder="请输入账户名">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col v-if="!this.subType" :span="9" style="text-align: left">
					<el-form-item label="用户类型：" prop="type">
						<el-select style="width: 100%" v-model="admin.type" size="small" :disabled="operate != 'add'" 
							placeholder="请选择用户类型" @change="changeAdminType">
							<el-option v-for="(value, key) in adminTypeMap" :key="parseInt(key)" :value="parseInt(key)"	
								:label="value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6"></el-col>
			</el-row>
			<el-row :gutter="50" type="flex" justify="space-between">
				<el-col v-if="!this.subType" :span="9" style="text-align: left">
					<el-form-item v-if="!admin.superAdmin" label="拥有角色：" prop="roleId">
						<el-select style="width: 100%" v-model="admin.roleId" size="small" :disabled="operate != 'add'" 
							placeholder="请选择角色">
							<el-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.name">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<!-- 机构/医院管理员显示管辖机构/医院 -->
				<el-col v-if="this.subType" :span="24" style="text-align: left">
					<el-form-item label="所辖医院：" class="is-required">
						<div class="hsp-dept-do-list">
							<div class="content">
								<div class="admin-hsp-list">
									<div class="title">
										<span>医院列表</span>
									</div>
									<el-checkbox class="checked-all" v-model="checkedAllHsp" :indeterminate="isIndeterminate" @change="checkAllChange" :disabled="registDisabled"
										v-if="hspDeptDOList.length">全选</el-checkbox>
									<div class="hsp" v-for="(item, index) in hspDeptDOList" :key="item.hospitalId" :class="item.hospitalId == curHsp.hospitalId ? 'activeHsp' : 'commonHsp'" @click.stop="handleClickHsp(item)">
										<el-checkbox v-model="item.hospitalSelectFlag" :true-label="1" :false-label="0" @change="(val)=>hspSelectFlagChange(val, index)" :disabled="registDisabled"></el-checkbox>
										<span>
											{{item.hospitalName}}
										</span>
									</div>
								</div>
								<div class="admin-dept-list">
									<div class="title">
										<span>科室列表</span>
									</div>
									<div class="filter-box" v-show="activeDeptList.length">
										<el-input placeholder="搜索" prefix-icon="el-icon-search" size="small" v-model="filterText"></el-input>
									</div>
									<el-checkbox class="checked-all" v-show="activeDeptList.length" v-model="checkedAllDept" :indeterminate="isIndeterminateDept" @change="handleCheckAllDeptChange" :disabled="registDisabled">全选</el-checkbox>
									<el-tree :data="activeDeptList" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps" :default-checked-keys="checkedKeys" :filter-node-method="filterNode" @check="handleCheckChange">
									</el-tree>
								</div>
							</div>
						</div>
					</el-form-item>
				</el-col>
				<el-col v-else-if="admin.type == 2 || admin.type == 3" :span="9" style="text-align: left">
					<el-form-item label="所属机构/医院：" prop="medicalInst">
						<el-select style="width: 100%;" value-key='id' size="small" :disabled="registDisabled" 
							v-model="admin.medicalInst" filterable clearable placeholder="请输入/选择"
							:filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'medicalInstList', srcMedicalInstList, this))"
							@visible-change="(visible) => 
								commonUtil.handleListFilterVisibleChange(visible, 'medicalInstList', srcMedicalInstList, this)">
							<el-option style="text-align: left;" v-for="(item, index) in medicalInstList" 
								:key="`${item.id}${index}`" :label="item.name" :value="parseInt(item.id)">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6"></el-col>
			</el-row>
			<el-row :gutter="50" type="flex" justify="space-between">
				<el-col :span="19">
					<el-form-item label="备注：" prop="remark">
						<el-input type="textarea" placeholder="请输入备注内容" maxlength="230" :disabled="registDisabled"	
							v-model="admin.remark" :rows="1">
						</el-input>
					</el-form-item>
				</el-col>					
			</el-row>
			<el-row v-if="subType" :gutter="50" type="flex" justify="space-between">
				<el-col :span="9" style="text-align: left">
					<el-form-item>
						<el-checkbox v-model="admin.isSetInstitutionAdmin" :true-label="1" :false-label="0" :disabled="!superAdmin || registDisabled">设为机构管理员</el-checkbox>
						<el-popover placement="right" width="230" trigger="hover">
							<span slot="reference" style="font-size: 20px;">
								<i class="el-icon-question" style="color: #3A7FF3; transform: translate(5px, 3px);"></i>
							</span>
							<div>一个机构只有一个机构管理员，勾选设成机构管理员替换原机构管理员，具有机构最高权限</div>
						</el-popover>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="admin.type == 2 || admin.type == 9 || subType" :gutter="50" type="flex" justify="space-between" style="margin-top: -10px;">
				<el-col :span="9" style="text-align: left">
					<el-form-item>
						<el-checkbox v-model="adminVO.isRegAttendant" :true-label="1" :false-label="0" :disabled="operate != 'add'"
							@change="handleChangeIsRegAttendant">同时注册为护工</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-if="adminVO.isRegAttendant" :gutter="50" type="flex" justify="space-between" aline-item="center" 
				style="margin-top: -10px;">
				<el-col :span="9" style="text-align: left">
					<el-form-item prop="idCardNo">
						<el-input v-model.trim="admin.idCardNo" size="small" maxlength="30" :disabled="operate != 'add'" 
							placeholder="请输入管理员真实身份证号">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="15" style="text-align: left">
					<el-form-item>
						<el-checkbox v-model="adminVO.dispatchFlag" :true-label="1" :false-label="0" :disabled="operate != 'add'">派单权</el-checkbox>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="dialog-footer bk-wizard-bottons" >
			<el-button @click="handleCancel('admin')">取 消</el-button>
			<template v-if="operate == 'add'">
				<el-button type="primary" @click="handleSaveClick('admin')">保 存</el-button>
			</template>
			<template v-else-if="operate == 'details' && registDisabled && canUpdate && ((!this.subType && dataPvgList.includes('ADMIN_2_UPDATE')) || (this.subType && dataPvgList.includes('ADMIN_6_SUB_UPDATE')))">
				<el-button type="primary" @click="handleEditClick">修 改</el-button>
			</template>
			<template v-else>
				<el-button v-show="canUpdate && ((!this.subType && dataPvgList.includes('ADMIN_2_UPDATE')) || (this.subType && dataPvgList.includes('ADMIN_6_SUB_UPDATE')))" type="primary" @click="handleSaveClick('admin')">保 存</el-button>
			</template>
		</div>
	</el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

export default {
	name: "AddAdminDialog",
	props: ["visible", "operate", "adminId", "canUpdate", "jumpType", "institutionId", "hospitalId", "subType", "instAdminId"],

	data() {
		let validateMobile = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入手机号'))
			} else if (!this.commonUtil.validateMobile(value) 
				&& this.initComprePhoneNub && this.initComprePhoneNub != this.admin.mobile) {
				callback(new Error('请输入正确的手机号码'))
			} else {
				callback()
			}
		}

		let validateEmail = (_rule, value, callback) => {
			console.log(Util.validateEmail(value))
			if (!value) {
				callback(new Error('请输入邮箱'))
			} else if (!Util.validateEmail(value)) {
				callback(new Error('邮箱格式不正确'))
			} else {
				callback()
			}
		}

		let validateRemark = (_rule, _value, callback) => {
			if (this.admin.remark && this.admin.remark.trim().length == 0) {
				callback(new Error('备注不能全输入空格或者换行等空白字符'));
			} else {
				callback();
			}
		}

		let validateIdNo = (_rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入真实身份证号'));
			} else if (value.length != 18 || !this.commonUtil.validateIdCardNo(value)) {
				callback(new Error('请输入正确的身份证号'));
			} else {
				callback();
			}
    }

		return {
			dataPvgList: [],    //在角色配置页面上的操作权限
			genderMap: {},
			registDisabled: false,
			roleWholeList: [],
			roleList: [],
			adminTypeMap: {},
			medicalInstList: [],
			srcMedicalInstList: [],
			admin: {},
			adminVO: {},
			logoFile: null,
			initComprePhoneNub: null,
			rules: {
				name: [{required: true, message: '请输入姓名', trigger: 'blur'},
							 {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}],
				gender: [{required: true, message: '请选择性别', trigger: 'blur'}],
				mobile: [{required: true, validator: validateMobile, trigger: 'blur'}],
				username: [{required: true,	message: '请输入账户名', trigger: 'blur'},],
				email: [{required: true, validator: validateEmail, trigger: 'blur'}],
				roleId: [{required: true, 	message: '请选择角色', trigger: 'blur'}, ],
				type: [{required: true, message: '请选择用户类型', trigger: 'blur'}, ],
				medicalInst: [{required: true, message: '请选择', trigger: 'blur'}, ],
				remark: [{required: false,validator: validateRemark, trigger: 'blur'},],
				idCardNo: [{required: true,validator: validateIdNo, trigger: 'blur'}],

			},

			isUniqueUserName: false,
			// 只有超管可以设置子管理员为机构管理员
			superAdmin: false,
			isIndeterminate: true,
			hspDeptDOList: [],
			checkedAllHsp: false,
      isIndeterminate: true,
      selectedHospital: [],
      curHsp: {},
			activeDeptList: [],
      checkedAllDept: false,
      isIndeterminateDept: true,
      defaultProps: {
        children: 'department2List',
        label: 'name',
				disabled: () => {
					return this.registDisabled;
				}
      },
      checkedKeys: [],
			filterText: '',
		}
	},

	computed: {
		dialogTitle() {
			if (this.operate == 'add' && this.subType) return '新增机构子管理员';
			else if (this.operate == 'add') return '新增管理员';
			else if (this.subType && this.registDisabled) return '机构子管理员详情'
			else if (this.subType && !this.registDisabled) return '编辑机构子管理员'
			else return this.registDisabled ? '管理员详情' : '编辑管理员';
		},

		photoPath() {
			if (this.logoFile) return this.commonUtil.file2Url(this.logoFile);
			return this.admin.photoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE
				, this.admin.photoPath)
				: require('@/assets/personal/icon-personal-default-photo.png');
		},

		previewImgList() {
			let imgList = [];
			if (this.admin.photoPath) {
				imgList.push(this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.admin.photoPath));
			}
			return imgList;
		}
	},

	methods: {
		openDialog() {
			this.registDisabled = this.operate != 'add';
			this.clearData();
			this.initData();
			this.getCurAdmin();
		},

		async initData() {
			this.getDataPvg4CurRole();
			if (this.subType) {
				await this.getSubDetailsOrDoData()
			} else {
				await this.getDetailsOrDoData();
			}
			if (this.admin.type == 2 || this.admin.type == 3) await this.getInstList();
		},

		getDataPvg4CurRole() {
			return new Promise((resolve) => {
				let requestData = {
					method: 'GET',
					url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
					param: {entityKey: 'ADMIN'},
				};
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.dataPvgList = result.data;
						resolve();
					}
				})
			})
		},

		// 获取当前选中医院科室的所有key
    getSelectedDeptKey() {
      this.checkedKeys = []
      this.activeDeptList.forEach((item) => {
        if (item.selectFlag) this.checkedKeys.push(item.id)
				if (item.department2List && item.department2List.length) {
					item.department2List.forEach((dept) => {
						if (dept.selectFlag) this.checkedKeys.push(dept.id)
					})
				}
      })
    },

		getDetailsOrDoData() {
				let url = this.operate == 'add' ? Constant.URL_GET_ADMIN_4_ADD : Constant.URL_GET_ADMIN_4_UPDATE;
				let params = this.operate == 'add' ? {} : {id: this.adminId};
				this.getDetails("GET", url, params);
		},

		getSubDetailsOrDoData() {
				let url = this.operate == 'add' ? Constant.URL_GET_SUB_ADMIN_DO4ADD : Constant.URL_GET_SUB_ADMIN_DO4UPDATE;
				let params = this.operate == 'add' ? {institutionId: this.institutionId} : {subadminId: this.adminId};
				this.getDetails("GET", url, params);
		},

		getAllSelectedDeptIds() {
			const selectedIds = [];
			
			this.hspDeptDOList.forEach(hospital => {
				// 只处理选中的医院
				if (hospital.hospitalSelectFlag !== 1) return;
				
				hospital.department1List.forEach(dept1 => {
					// 一级科室被选中
					if (dept1.selectFlag === 1) {
						selectedIds.push(dept1.id);
					}
					
					// 处理二级科室
					if (dept1.department2List && dept1.department2List.length) {
						dept1.department2List.forEach(dept2 => {
							if (dept2.selectFlag === 1) {
								selectedIds.push(dept2.id);
							}
						});
					}
				});
			});
			
			return selectedIds;
		},
		
		getDetails(method, url, params) {
			return new Promise((resolve) => {
				let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

				this.vueRequest(requestData).then(result => {
					if (!result) return;
					this.genderMap = result.data.genderMap;
					this.roleWholeList = this.changeRoleMapToList(result.data.typeRelationRoleMap);
					this.roleList = this.changeRoleMapToList(result.data.typeRelationRoleMap);
					this.adminTypeMap = result.data.adminTypeMap;
					this.admin = result.data.admin;
					this.checkedAllHsp = true;
					if (this.subType) {
						this.initTreeData(result);
						if (this.operate != 'add') {
							this.$set(this.admin, 'isSetInstitutionAdmin', result.data.isSetInstitutionAdmin)
							this.$set(this.admin, 'medicalInst', result.data.admin.medicalInstList.map(item => item.id))
							this.$set(this.adminVO, 'isRegAttendant', result.data.isRegAttendant)
							this.$set(this.admin, 'idCardNo', result.data.idCardNo)
							this.$set(this.adminVO, 'dispatchFlag', result.data.dispatchFlag)
						}
					} else {
						this.medicalInstList = result.data.admin.medicalInstList;
						this.srcMedicalInstList = result.data.admin.medicalInstList;
						this.admin = this.operate == 'add' ? 
							this.initDataAddDo(result.data.admin) : this.initDataEditDo(result.data.admin)
						if (this.operate != 'add') {
							this.$set(this.adminVO, 'isRegAttendant', result.data.isRegAttendant)
							this.$set(this.admin, 'idCardNo', result.data.idCardNo)
							this.$set(this.adminVO, 'dispatchFlag', result.data.dispatchFlag)
						}
					}
					resolve();
				})
			})
		},

		//初始化子管理员treeData
		initTreeData(result) {
			this.hspDeptDOList = result.data.hospitalDepartmentDOList || []
			if (this.hspDeptDOList.length > 0) {
				this.curHsp = this.hspDeptDOList[0]
				this.activeDeptList = this.curHsp.department1List || []
				this.checkedAllDept = this.curHsp.hospitalSelectFlag ? true : false
				this.isIndeterminateDept = this.curHsp.deptPartSelectFlag ? true : false
			}
		},

		initDataAddDo(obj) {
			let result = obj;
			result.gender = "";
			result.roleId = "";
			result.type = "";
			this.$set(result, 'medicalInst', '');
			result.medicalInstList = [];
			//新增机构后跳转显示类型为机构管理员，新增医院后跳转显示类型为医院管理员,并且管辖机构/医院填充新增的机构/医院
			if (this.jumpType == 'instAdd') {
				this.getHspOrInstList('inst')
				result.type = 2
				if (this.institutionId) this.$set(result, 'medicalInst', this.institutionId);
			} else if (this.jumpType == 'hspAdd') {
				this.getHspOrInstList('hsp')
				result.type = 3
				if (this.hospitalId) this.$set(result, 'medicalInst', this.hospitalId);
			}
			if (result.type) {
				this.roleList = this.filterRoleListByAdminType(result.type);
				result.roleId = this.roleList[0].id;
			}
			return result;
		},

		initDataEditDo(obj) {
			let result = obj;
			this.initComprePhoneNub = obj.mobile;
			if (obj.medicalInstList && obj.medicalInstList.length) {
				this.$set(result, 'medicalInst', obj.medicalInstList[0].id);
			} else {
				this.$set(result, 'medicalInst', '');
			}
			return result;
		},

		getHspOrInstList(type) {
			return new Promise((resolve) => {
        let params = {adminTypeStr: type};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_LIST_MEDICAL_INSTS_BY_ADMIN_TYPE,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.medicalInstList = result.data || [];
						this.srcMedicalInstList = result.data || [];
						resolve();
					}
				})
			})
		},

		getInstList() {
			return new Promise((resolve) => {
				let adminType = this.admin.type == 2 ? 'inst' : 'hsp';
        let params = {adminTypeStr: adminType};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_LIST_MEDICAL_INSTS_BY_ADMIN_TYPE,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.medicalInstList = result.data;
						this.srcMedicalInstList = result.data;
						resolve();
					}
				})
			})
		},

		// 选中医院
    getSelectedHsp(data) {
      const arr = JSON.parse(JSON.stringify(data));
      const result = [];

      for (const obj of arr) {
        if (obj.hospitalSelectFlag === 1 && !obj.deptPartSelectFlag) {
          result.push({
            hospitalId: obj.hospitalId,
            hospitalName: obj.hospitalName + '(全部科室)',
          });
        } else if (obj.hospitalSelectFlag === 1) {
          const hospitalName = this.generateHspName(obj);
          if (hospitalName) {
            result.push({
              hospitalId: obj.hospitalId,
              hospitalName: hospitalName
            });
          }
        }
      }

      this.$set(this, 'selectedHospital', result);
    },

		generateHspName(obj) {
      const selectedDepts = obj.department1List.map(dept1 => {
        if (dept1.selectFlag === 1) {
          return dept1.name;
        }
        
				if (dept1.department2List && dept1.department2List.length) {
					const dept1Names = dept1.department2List
						.filter(dept2 => dept2.selectFlag === 1)
						.map(dept2 => dept2.name);
					
					return dept1Names.length > 0 ? `${dept1.name}-${dept1Names.join('、')}` : null;
				}
      }).filter(Boolean); // 移除 null 和 undefined

      return selectedDepts.length > 0 ? `${obj.hospitalName}(${selectedDepts.join('; ')})` : null;
    },

		//角色类型切换
		changeAdminType(val) {
			this.admin.medicalInst = '';
			this.admin.medicalInstList = [];
			this.roleList = this.filterRoleListByAdminType(val);
			this.admin.roleId = this.roleList[0].id;
			if (this.admin.type == 2 || this.admin.type == 3) {
				this.getInstList();
			}
		},

		// 切换是否注册护工
		handleChangeIsRegAttendant() {
			if (this.adminVO.isRegAttendant) return
			this.$set(this.admin, 'idCardNo', '')
			this.$set(this.adminVO, 'dispatchFlag', 0)
		},

		handleAdminLogoChange(file, _fileList) {
			let limitation = {
				maxSize: Constant.LIMIT_IMG_SIZE_2,
				maxWidth: 100.0,
				maxHeight: 0,
				extLimit: {
					limitType: 2,
					minRatio: 0.01,
					minRatioText: '100:1',
				},
				returnData: {}
			};
			this.imgUtil.validateAndCompressImg(file, limitation).then((data) => {
				if (data.errorText && data.errorText.length) {
					this.$message.error(data.errorText);
				} else {
					this.logoFile = data.file;
				}
			})
		},

		//修改为编辑状态
		handleEditClick() {
			this.registDisabled = false;
		},

		hspSelectFlagChange(val, index) {
			this.hspDeptDOList[index].deptPartSelectFlag = false
      this.hspDeptDOList[index].hospitalSelectFlag = val ? 1 : 0
      Array.from(this.hspDeptDOList[index].department1List, (dept) => {
        dept.selectFlag = val ? 1 : 0
				if (dept.department2List && dept.department2List.length) {
       		Array.from(dept.department2List, (dept2) => (dept2.selectFlag = val ? 1 : 0))
				}
        return dept
      })
      if (this.curHsp.hospitalId === this.hspDeptDOList[index].hospitalId) {
        this.activeDeptList = this.hspDeptDOList[index].department1List
        this.checkedAllDept = val ? true : false
        this.isIndeterminateDept = false
      }
		},

		// 切换当前选中医院
    handleClickHsp(item) {
      this.curHsp = item
      this.activeDeptList = this.curHsp.department1List
      this.checkedAllDept = item.hospitalSelectFlag ? true : false
      this.isIndeterminateDept = item.deptPartSelectFlag ? true : false
    },

    // 医院全选状态修改
    checkAllChange(val) {
      this.setHspSelectFlags(val);
      this.setCheckedKeys(val);
      this.setIndeterminateDept(false);
    },

    setHspSelectFlags(val) {
      for (const item of this.hspDeptDOList) {
        item.hospitalSelectFlag = val ? 1 : 0;
        item.deptPartSelectFlag = false;
        this.setDeptSelectFlags(item.department1List, val);
      }
    },

		setIndeterminateDept(val) {
      this.isIndeterminateDept = val;
    },

    setDeptSelectFlags(department1List, val) {
      for (const dept of department1List) {
        dept.selectFlag = val ? 1 : 0;
				if (dept.department2List && dept.department2List.length) this.setDept2SelectFlags(dept.department2List, val);
      }
    },

    setDept2SelectFlags(department2List, val) {
      for (const dept2 of department2List) {
        dept2.selectFlag = val ? 1 : 0;
      }
    },

		// 科室全选状态修改
    handleCheckAllDeptChange(val) {
      this.checkedKeys = []
      this.checkedAllDept = val ? true : false
      this.isIndeterminateDept = false

      this.activeDeptList.forEach((item) => {
        if (val) this.checkedKeys.push(item.id)
        item.selectFlag = val ? 1 : 0
				if (item.department2List && item.department2List.length) {
					item.department2List.forEach((item2) => {
						item2.selectFlag = val ? 1 : 0
					})
				}
      })

      if (!val) {
        this.$refs.tree.setCheckedKeys([])
      }

      let index = this.hspDeptDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      this.$set(this.hspDeptDOList[index], 'department1List', this.activeDeptList)
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', val ? 1 : 0)
      this.$set(this.hspDeptDOList[index], 'deptPartSelectFlag', false)
    },

		handleCheckChange() {
			let checkArr = this.$refs.tree.getCheckedKeys()
      this.activeDeptList.forEach((item) => {
        item.selectFlag = 0
        if (checkArr.includes(item.id)) {
          item.selectFlag = 1
        }
        if (item.department2List && item.department2List.length) {
					item.department2List.forEach((dept) => {
          dept.selectFlag = 0
          if (checkArr.includes(dept.id)) {
            dept.selectFlag = 1
            return false
          }
        })
				}
      })

      let arr = []
      this.activeDeptList.forEach((item) => {
        arr.push(item.id)
				 if (item.department2List && item.department2List.length) {
					item.department2List.forEach((dept) => {
						arr.push(dept.id)
					})
				 }
      })
      if (!checkArr.length) {
          this.checkedAllDept = false
          this.isIndeterminateDept = false
        } else if (checkArr.length === arr.length) {
          this.checkedAllDept = true
          this.isIndeterminateDept = false
        } else {
          this.checkedAllDept = true
          this.isIndeterminateDept = true
        }

      let index = this.hspDeptDOList.findIndex(
        (item) => item.hospitalId === this.curHsp.hospitalId
      )
      let flag =  this.checkedAllDept ? 1 : 0
      this.$set(this.hspDeptDOList[index], 'department1List', this.activeDeptList)
      this.$set(this.hspDeptDOList[index], 'hospitalSelectFlag', flag)
      this.$set(this.hspDeptDOList[index], 'deptPartSelectFlag', this.isIndeterminateDept)
    },

		setCheckedKeys(val) {
      this.checkedKeys = [];
      if (val) {
        this.checkedAllDept = true;
        for (const item of this.activeDeptList) {
          this.checkedKeys.push(item.id);
        }
      } else {
        this.checkedAllDept = false;
        this.$refs.tree.setCheckedKeys([]);
      }
    },

		//判断用户名是否唯一
		checkIsUniqueUserName() {
      let params = {
				username: this.admin.username,
				excludeId: this.adminId
			};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_IS_UNIQUE_USER_NAME,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(result => {
				if (result == null) return;
				this.isUniqueUserName = result.data;
				if (!this.isUniqueUserName) {
					this.$message.error('账户名已存在');
					return;
				}
				if (this.subType) this.submitSubData();
				else this.submitData();
			})
		},

		//保存接口调用
		handleSaveClick() {
			this.$refs.adminForm.validate((valid) => {
				if (!valid) return false;
				this.checkIsUniqueUserName();
			})
		},

		submitData() {
			let url = (this.operate == 'add') ? Constant.URL_SAVE_ADMIN : Constant.URL_UPDATE_ADMIN;
			let method = (this.operate == 'add') ? 'POST' : 'PUT';
			let form = JSON.parse(JSON.stringify(this.admin));
			if (this.admin.medicalInst) {
				form.medicalInstList = [this.admin.medicalInst];
			} else {
				form.medicalInstList = [];
			}
			this.adminVO.isSetInstitutionAdmin = form.isSetInstitutionAdmin
			this.adminVO.idCardNo = form.idCardNo
			this.$delete(form, 'isSetInstitutionAdmin');
			this.$delete(form, 'idCardNo');
			this.$delete(form, 'medicalInst');
			if (this.operate != 'add' && form.mobile == this.initComprePhoneNub) {
				this.$delete(form, 'mobile');
			} 
			this.adminVO.admin = {...form}
			let formVO = JSON.parse(JSON.stringify(this.adminVO))
			let fileMap = new Map();
			if (this.logoFile && this.logoFile.raw) {
				fileMap.set((this.operate == 'add' ? 'photoFile' : 'file'), this.logoFile.raw);
			}
			let param = {'name': 'adminVO', 'value': {...formVO}};
			this.sendSubmitReq(method, url, param, fileMap); 
		},

		validSubAdminData() {
			if (!this.selectedHospital.length) {
				this.$message.warning('请至少选择一家所辖医院');
				return false
			}

			return true
		},

		submitSubData() {
			if (!this.validSubAdminData()) return
			let url = (this.operate == 'add' && this.subType) ? Constant.URL_SAVE_SUB_ADMIN : Constant.URL_UPDATE_SUB_ADMIN;
			let method = (this.operate == 'add' && this.subType) ? 'POST' : 'PUT';
			let form = JSON.parse(JSON.stringify(this.admin));
			form.type = 4
			form.departmentIdList = this.getAllSelectedDeptIds();
			console.log(this.getAllSelectedDeptIds())
			form.medicalInstList = this.selectedHospital.map(item=> item.hospitalId);
			this.adminVO.isSetInstitutionAdmin = form.isSetInstitutionAdmin
			this.adminVO.idCardNo = form.idCardNo
			this.adminVO.instAdminId = this.instAdminId
			this.$delete(form, 'medicalInst');
			this.$delete(form, 'isSetInstitutionAdmin');
			this.$delete(form, 'idCardNo');
			this.adminVO.admin = {...form}
			this.adminVO.institutionId = this.institutionId
			let subFormVO = JSON.parse(JSON.stringify(this.adminVO))
			let fileMap = new Map();
			if (this.logoFile && this.logoFile.raw) {
				fileMap.set((this.operate == 'add' ? 'photoFile' : 'file'), this.logoFile.raw);
			}
			let param = {'name': 'adminVO', 'value': {...subFormVO}};
			this.sendSubmitReq(method, url, param, fileMap);
		},

		sendSubmitReq(method, url, param, fileMap) {
			let [header, esParams] = this.encryptionUtil.encryptAndSignObjectParam(
				param, Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY, 
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        url: url,
        method: method,
        contentType: this.commonConst.CNTYPE_JSON,
        header: header,
        param: esParams,
        files: fileMap
      };

			this.vueRequest(requestData).then(result => {
				if (result != null) {
					this.clearData();
					this.$emit("close-dialog", true);
				}
			})
		},

		getCurAdmin() {
			let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
			if (!adminType) adminType = 'global';

			let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_CURRENT_ADMIN_INSTITUTION, adminType, 'false');
			this.appAxios("GET", url).then(result => {
				if (result != null) {
					this.superAdmin = (result.data.type == 1 || result.data.type == 9) ? true : false
				}
			})
		},

		handleCloseDialog() {
			this.clearData();
			this.$emit("close-dialog", false);
		},

		//取消弹框
		handleCancel(_admin) {
			this.clearData();
			this.$emit("close-dialog", false);
		},

		clearVaild() {
			this.$nextTick(() => {
				this.$refs["adminForm"].clearValidate();
			});
		},

		//清空表单
		clearData() {
			this.clearVaild();
			this.admin = {isSetInstitutionAdmin: 0};
			this.adminVO = {isRegAttendant: 0}
			this.logoFile = '';
			this.initComprePhoneNub = null;
			this.activeDeptList = [];
			this.hospitalDepartmentDOList = [];
		},

		filterRoleListByAdminType(type) {
			let list = [];
			this.roleWholeList.forEach(item => {
				if (item.type == type) list.push(item);
			});
			return list;
		},

		filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },

		changeRoleMapToList(map) {
			let list = [];
			for (const i in map) {
				let obj = map[i];
				obj.forEach((item) => {
					item.type = i;
					list.push(item);
				});
				obj.type = i;
			}
			return list;
		},
	},

		watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },

    hspDeptDOList: {
      handler(newVal, _oldVal) {
        const count1 = this.hspDeptDOList.filter(
          (hospital) => hospital.hospitalSelectFlag === 1 && !hospital.deptPartSelectFlag
        ).length
        const count2 = this.hspDeptDOList.filter(
          (hospital) => hospital.hospitalSelectFlag === 0).length

          if (count1 === this.hspDeptDOList.length) {
          this.isIndeterminate = false
          this.checkedAllHsp = true
        } else if (count2 === this.hspDeptDOList.length) {
          this.isIndeterminate = false
          this.checkedAllHsp = false
        } else {
          this.isIndeterminate = true
          this.checkedAllHsp = false
        }
        this.getSelectedHsp(newVal)
      },
      deep: true,
      immediate: true,
    },

    activeDeptList: {
      handler(newVal, _oldVal) {
        this.getSelectedDeptKey()
				const trueFlagCount = newVal.filter(obj => obj.selectFlag).length;
        if (!trueFlagCount) {
          // 不选
					if (this.$refs && this.$refs.tree) this.$refs.tree.setCheckedKeys([])
          this.checkedAllDept = false;
          this.isIndeterminateDept = false;
        } else if (trueFlagCount === newVal.length) {
          // 全选
          this.checkedAllDept = true;
          this.isIndeterminateDept = false;
        } else {
          // 部分选
          this.checkedAllDept = true;
          this.isIndeterminateDept = true;
        }
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.el-upload {
	display: inline-block;
	text-align: center;
	cursor: pointer;
	border: 1px solid #ccc !important;
	border-radius: 46px;
	margin: 50px 140px;
}
.avatar-uploader {
	width: 88px;
	height: 88px;
}
.avatar-uploader .el-upload {
	width: 88px;
	height: 88px;
	border: 1px dashed #eeeeee;
	border-radius: 44px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 88px;
	height: 88px;
	line-height: 88px;
	border-radius: 44px;
	text-align: center;
}
.avatar {
	width: 88px;
	height: 88px;
	display: block;
	border-radius: 44px;
}
.dialog-footer {
	text-align: center;
}
.avatar-uploader .el-upload:hover .text-logo-hover {
  display: block; 
}
.avatar-uploader .text-logo-hover {
  display: none;
  font-size: 8px;
  text-align: center;
  z-index: 200;
  position: absolute;
  top: 0px;
  left: 0px;
  width:88px;
  height: 88px;
  line-height: 88px;
	border-radius: 44px;
  background: rgba(124,124,124,0.5500);
  font-weight: 600;
  color: #FFFFFF;
}
.adminForm >>> .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}
</style>
<style>
.dialog-admin .el-form--label-top .el-form-item__label {
	padding: 0px;
  line-height: 26px;
}

.hospital,
.hsp-dept-do-list {
  background-color: #f7f8fa;
}
.hospital {
  padding: 10px 30px;
}
.hsp-dept-do-list {
  position: relative;
  max-height: 464px;
  overflow-y: auto;
}
.hsp-dept-do-list .content {
  margin: 22px 25px;
  background: #fff;
  display: flex;
}
.admin-hsp-list,
.admin-dept-list {
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #e7e7e7;
}
.admin-hsp-list {
  width: 315px;
}
.admin-dept-list {
  flex: 1;
}
.hsp-name {
  color: #606266;
  font-weight: 500;
  cursor: pointer;
}
.hospital >>> .el-tag {
  margin: 0 10px 10px 0;
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  white-space: normal;
  height: auto;
  padding: 0 10px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.hospital >>> .el-tag .el-icon-close {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 12px;
  width: 12px;
  line-height: 12px;
  vertical-align: middle;
  top: -1px;
  right: -5px;
  color: #949da6;
  border: 1px solid #949da6;
}
.hospital >>> .el-tag .el-icon-close:hover {
  color: #fff;
  border: 1px solid #e6f1fc;
}
.admin-hsp-list .title,.admin-dept-list .title {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #5b5b5b;
  font-size: 14px;
  margin-bottom: 10px;
}
.hsp {
  padding: 10px 15px;
}
.activeHsp {
  background: #f4f7ff;
  cursor: pointer;
}
.commonHsp {
  background: #fff;
  cursor: pointer;
}
.checked-all {
  margin: 10px 15px;
}
.group {
  margin: 20px 36px 0;
}
.el-tree {
  padding: 0 10px;
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.admin-dept-list >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #fff !important;
}
.filter-box {
  padding: 0 15px;
}
.filter-box >>> .el-input__inner {
  border-radius: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/usermng/components/AdminDetails.vue